import React from 'react';
import { Monitor, Smartphone, Headphones, Users } from 'lucide-react';
export const HowItWorks = () => {
  return <section id="how-it-works" className="py-24 relative overflow-hidden" data-id="element-208">
      <div className="absolute -bottom-40 left-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-209"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] gradient-circle opacity-20" data-id="element-210"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-211">
        <div className="max-w-3xl mx-auto text-center mb-16 reveal" data-id="element-212">
          <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#00d4ff]" data-id="element-213">
            WE BUILD BUYER CONFIDENCE
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-214">
            Bringing Unbuilt Spaces to{' '}
            <span className="text-gradient" data-id="element-215">Life</span>
          </h2>
          <p className="text-lg text-gray-300" data-id="element-216">
            Our two-phase process transforms architectural plans into immersive
            experiences.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-217">
          <div className="reveal" data-id="element-218">
            <div className="relative" data-id="element-219">
              <div className="absolute inset-0 bg-gradient-to-tr from-[rgba(26,11,46,0.4)] to-[rgba(0,212,255,0.2)] rounded-xl z-10" data-id="element-220"></div>
              <img src="https://images.unsplash.com/photo-1558442074-3c19857bc1dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Abstract 3D building model" className="rounded-xl shadow-xl w-full h-auto relative z-0 mix-blend-luminosity" data-id="element-221" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-glass rounded-lg z-0 animate-float-delayed" data-id="element-222"></div>
              {/* Floating Toggle Icons */}
              <div className="absolute top-1/4 right-1/4 w-12 h-12 bg-glass rounded-full z-20 flex items-center justify-center p-2 neon-border animate-float" data-id="element-223">
                <div className="w-full h-full bg-[rgba(0,212,255,0.3)] rounded-full" data-id="element-224"></div>
              </div>
              <div className="absolute bottom-1/3 left-1/4 w-10 h-10 bg-glass rounded-full z-20 flex items-center justify-center p-2 neon-border animate-float-delayed" data-id="element-225">
                <div className="w-full h-full bg-[rgba(166,76,255,0.3)] rounded-full" data-id="element-226"></div>
              </div>
              {/* Holographic UI Element */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] z-20 opacity-60 hologram-grid rounded-lg" data-id="element-227"></div>
            </div>
          </div>
          <div className="reveal" data-id="element-228">
            <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#00d4ff]" data-id="element-229">
              Phase 1
            </div>
            <h3 className="text-2xl font-bold mb-8 text-gradient" data-id="element-230">
              Digital Showroom Experience
            </h3>
            <div className="space-y-8" data-id="element-231">
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-232">
                <div className="flex" data-id="element-233">
                  <div className="flex-shrink-0" data-id="element-234">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(0,212,255,0.2)]" data-id="element-235">
                      <Monitor size={20} className="text-[#00d4ff]" data-id="element-236" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-237">
                    <h4 className="text-xl font-semibold" data-id="element-238">
                      Interactive 3D Models
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-239">
                      Explore detailed 3D models of properties with the ability
                      to rotate, zoom, and view from any angle.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-240">
                <div className="flex" data-id="element-241">
                  <div className="flex-shrink-0" data-id="element-242">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(255,0,128,0.2)]" data-id="element-243">
                      <Smartphone size={20} className="text-[#ff0080]" data-id="element-244" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-245">
                    <h4 className="text-xl font-semibold" data-id="element-246">
                      Personalization Tools
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-247">
                      Interactive 3D models and customization tools let buyers
                      explore, rotate, and personalize properties even before
                      they're built.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-24" data-id="element-248"></div>
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-249">
          <div className="order-2 md:order-1 reveal" data-id="element-250">
            <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#ff0080]" data-id="element-251">
              Phase 2
            </div>
            <h3 className="text-2xl font-bold mb-8 text-gradient" data-id="element-252">
              Immersive VR Tour
            </h3>
            <div className="space-y-8" data-id="element-253">
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-254">
                <div className="flex" data-id="element-255">
                  <div className="flex-shrink-0" data-id="element-256">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(0,212,255,0.2)]" data-id="element-257">
                      <Headphones size={20} className="text-[#00d4ff]" data-id="element-258" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-259">
                    <h4 className="text-xl font-semibold" data-id="element-260">Full Immersion</h4>
                    <p className="mt-2 text-gray-300" data-id="element-261">
                      Clients step into their future home with VR headsets full
                      immersion, guided or self-paced tours, no travel required.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-262">
                <div className="flex" data-id="element-263">
                  <div className="flex-shrink-0" data-id="element-264">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(255,0,128,0.2)]" data-id="element-265">
                      <Users size={20} className="text-[#ff0080]" data-id="element-266" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-267">
                    <h4 className="text-xl font-semibold" data-id="element-268">
                      Guided or Self-Directed
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-269">
                      Choose between a guided tour with a virtual agent or
                      explore at your own pace with interactive hotspots and
                      information markers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2 reveal" data-id="element-270">
            <div className="relative" data-id="element-271">
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-glass rounded-lg z-0 animate-float" data-id="element-272"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-[rgba(26,11,46,0.4)] to-[rgba(255,0,128,0.2)] rounded-xl z-10" data-id="element-273"></div>
              <img src="https://images.unsplash.com/photo-1626379953822-baec19c3accd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Person with VR headset stepping into holographic house" className="rounded-xl shadow-xl w-full h-auto relative z-0 mix-blend-luminosity" data-id="element-274" />
              {/* Holographic House Outline */}
              <div className="absolute top-0 left-0 w-full h-full z-20 opacity-40" data-id="element-275">
                <div className="w-full h-full hologram-grid rounded-lg" data-id="element-276"></div>
              </div>
              {/* VR Headset Element */}
              <div className="absolute -top-4 right-4 w-28 h-28 bg-glass rounded-full z-20 flex items-center justify-center p-2 neon-border animate-float" data-id="element-277">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vvS3KjqGCM41zdLEffR3fA/vr_hand.png" alt="VR Headset with hand" className="w-full h-full object-cover rounded-full" data-id="element-278" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};